import React from 'react';
import { Plus, RefreshCw } from 'lucide-react';
import { Button } from '../ui/button';

const FleetSecurityTab = ({ fleetOverview, fleetVehicleForm, setFleetVehicleForm, registerFleetVehicle, fetchFleetOverview, getSeverityColor }) => (
  <div className="space-y-6">
    <div className="bg-white rounded-xl border shadow-sm p-6">
      <div className="flex items-center justify-between mb-4">
        <h3 className="font-semibold text-gray-900">Fleet Security Management</h3>
        <Button onClick={() => fetchFleetOverview('FLEET-001')} variant="outline"><RefreshCw className="h-4 w-4 mr-2" />Load Fleet</Button>
      </div>
      <form onSubmit={registerFleetVehicle} className="p-4 bg-gray-50 rounded-lg mb-6">
        <h4 className="font-medium text-gray-900 mb-3">Register Vehicle to Fleet</h4>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
          {[
            { label: 'Vehicle ID', field: 'vehicle_id', placeholder: 'VEH-001' },
            { label: 'VIN', field: 'vin', placeholder: '1HGBH41JXMN109186' },
            { label: 'Make', field: 'make', placeholder: 'Toyota' },
            { label: 'Model', field: 'model', placeholder: 'Camry' },
          ].map(({ label, field, placeholder }) => (
            <div key={field}>
              <label className="block text-sm font-medium text-gray-700 mb-1">{label}</label>
              <input type="text" required value={fleetVehicleForm[field]}
                onChange={(e) => setFleetVehicleForm({ ...fleetVehicleForm, [field]: e.target.value })}
                className="w-full px-3 py-2 border rounded-lg text-sm" placeholder={placeholder} />
            </div>
          ))}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Vehicle Type</label>
            <select value={fleetVehicleForm.vehicle_type} onChange={(e) => setFleetVehicleForm({ ...fleetVehicleForm, vehicle_type: e.target.value })} className="w-full px-3 py-2 border rounded-lg text-sm">
              {['sedan', 'suv', 'truck', 'van', 'bus'].map(t => <option key={t} value={t}>{t.charAt(0).toUpperCase() + t.slice(1)}</option>)}
            </select>
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Security Policy</label>
            <select value={fleetVehicleForm.security_policy} onChange={(e) => setFleetVehicleForm({ ...fleetVehicleForm, security_policy: e.target.value })} className="w-full px-3 py-2 border rounded-lg text-sm">
              {['standard', 'enhanced', 'strict'].map(p => <option key={p} value={p}>{p.charAt(0).toUpperCase() + p.slice(1)}</option>)}
            </select>
          </div>
          <div className="flex items-end">
            <Button type="submit" className="bg-green-600 hover:bg-green-700"><Plus className="h-4 w-4 mr-2" />Register</Button>
          </div>
        </div>
      </form>
      {fleetOverview && fleetOverview.total_vehicles > 0 && (
        <div className="border rounded-lg overflow-hidden">
          <div className="p-4 bg-gradient-to-r from-indigo-600 to-purple-600 text-white">
            <div className="flex items-center justify-between">
              <div><h4 className="font-semibold">Fleet: {fleetOverview.fleet_id}</h4><p className="text-indigo-200 text-sm">{fleetOverview.total_vehicles} Vehicles</p></div>
              <div className="text-right"><p className="text-3xl font-bold">{fleetOverview.fleet_risk_score}</p><p className="text-xs text-indigo-200">Risk Score</p></div>
            </div>
          </div>
          <div className="p-4">
            <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-4">
              {Object.entries(fleetOverview.threat_distribution || {}).map(([level, count]) => (
                <div key={level} className={`text-center p-2 rounded ${getSeverityColor(level)}`}><p className="text-xl font-bold">{count}</p><p className="text-xs capitalize">{level}</p></div>
              ))}
            </div>
            {fleetOverview.recommendations?.filter(r => r).length > 0 && (
              <div className="p-3 bg-blue-50 rounded-lg">
                <h5 className="font-medium text-blue-800 mb-2">Recommendations:</h5>
                {fleetOverview.recommendations.filter(r => r).map((rec) => (<p key={rec} className="text-sm text-blue-700">&#10003; {rec}</p>))}
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  </div>
);

export default FleetSecurityTab;
